import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  Grid,
} from 'react-virtualized'

import styles from './styles.scss'

class LeftHeaderGrid extends Component {
  static propTypes = {
    getCache: PropTypes.func.isRequired,
    cellRenderer: PropTypes.func.isRequired,
    leftGridParams: PropTypes.object.isRequired,
    headerGridParams: PropTypes.object.isRequired,
  }

  componentDidMount() {
    if (this.props.register)
      this.props.register(this.grid)
  }

  componentWillUnmount() {
    if (this.props.unregister)
      this.props.unregister(this.grid)
  }

  setRef = (ref)  => this.grid = ref

  render() {
    const {
      getCache,
      leftGridParams,
      headerGridParams,
      cellRenderer,
    } = this.props
    const {
      columnCount,
      columnWidth,
    } = leftGridParams
    const {
      rowCount,
      rowHeight,
    } = headerGridParams
    const cache = getCache()

    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: rowHeight,
          width: columnWidth
        }}
        styleName='leftSideHeaderContainer'
      >
        <Grid
          ref={this.setRef}
          deferredMeasurementCache={cache}
          cellRenderer={cellRenderer}
          columnCount={columnCount}
          columnWidth={columnWidth}
          height={rowHeight}
          rowHeight={rowHeight}
          rowCount={rowCount}
          styleName='headerGrid'
          width={columnWidth}
        />
      </div>
    )
  }
}

export default CSSModules(styles, LeftHeaderGrid)
